<template>
  <div>
    <b-modal :no-close-on-backdrop="true" id="modal-add-clinic-patient" ok-only centered size="lg"
      :title="$t('Add Patient')" @ok="submitItem()">
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input id="Name" v-model="addForm.name" :placeholder="$t('common.name')" />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('clinic.mother-name')" label-for="Name">

              <b-form-input id="Name" v-model="addForm.mother_name" :placeholder="$t('clinic.mother-name')" />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('reception.phone')" label-for="phoneNumber">
              <VuePhoneNumberInput v-model="addForm.phone" @update="(obj) => {
        showPhoneObj(obj, 'countryCallingCode');
      }
      " default-country-code="IQ" :error="addForm.phone
        ? isNotValid || addForm.phone[0] != 0
        : false
      " />

            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('reception.birth-date')" label-for="entry_date">
              <datepicker v-model="addForm.birth_date" :calendar-button="true" :clear-button="true"
                :bootstrap-styling="true" class="datebtn2" placeholder="YYYY-MM-DD"></datepicker>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('reception.gender')" label-for="Gender">
              <v-select v-model="addForm.gender" :options="genderOption" :placeholder="$t('reception.gender')" />
            </b-form-group>
          </b-col>
          <b-col md="6">
          <AutoComplete
            :label="$t('reception.governorate')"
            :placeholder="$t('reception.governorate')"
            v-model="addForm.governorate_id"
            :serializer="(val) => val.id"
            param-query="search"
            endpoint="governorate"
            text-title="name"
          />
          </b-col>
          
              <b-col md="6">
              <AutoComplete
            :label="$t('reception.city-name')"
            :placeholder="$t('reception.city-name')"
            v-model="addForm.city_name"
            :serializer="(val) => val.name"
            param-query="search"
            endpoint="city"
            text-title="name"
          />
          </b-col>
           <b-col  cols="12">

            <ServicePriceAutoComplete
            :label="$t('hospital.services')"
            :placeholder="$t('hospital.services')"
            :serializer="(val) => val"
            param-query="search"
            text-title="title"
            @val="serviceValue($event)"
          />
            </b-col>
          <b-col md="12">
            <b-form-group :label="$t('reception.patient-case')" label-for="Case">
              <b-form-input id="Case" v-model="addForm.patient_case" :placeholder="$t('reception.patient-case')" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card no-body>
      <!-- Search Patient Name -->
      <div class="m-2">
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t('common.search') }}</h2>
            <br />
          </b-col>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group :label="$t('common.patient-name')" label-for="Name">
              <b-form-input id="Name" v-model="patientName" :placeholder="$t('common.patient-name')" />
            </b-form-group>
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('reception.patient-mother-name')" label-for="Name">
              <b-form-input id="Name" v-model="patientMotherName" :placeholder="$t('reception.patient-mother-name')" />
            </b-form-group>
          </b-col>
          <b-col class="d-flex align-items-center" md="2" cols="12">
            <b-button variant="primary" @click="getClinicPatients()" class="w-100">
              {{ $t('common.search') }}
              <b-icon-search class="ml-1" style="font-size: smaller"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>

        <!-- Search Button -->

        <b-col cols="12" md="12" class="d-flex align-items-center justify-content-between mt-3 mb-1 mb-md-0">
          <h2>{{ $t('clinic.patients-in-clinic') }} </h2>

          <b-button v-if="$store.state.app.permissions.includes('store-patient')" variant="primary" @click="show">
            {{ $t('common.Add Patient') }}
          </b-button>
        </b-col>
        </b-row>
      </div>

      <!-- Data Table  -->
      <b-table :items="this.patientsData" responsive :fields="tableColumns" primary-key="id" show-empty
        empty-text="No matching patients found" class="position-relative" v-if="!loading">
        <!-- Column: Phone -->
        <template #cell(Phone)="data">
          <span class="text-nowrap">
            {{ data.item.phone }}
          </span>
        </template>

        <template #cell(actions)="data">
          <div class="text-nowrap d-flex">
            <!-- <ActionsButtons
              noEdit="true"
              deletePerm="delete-patient"
              editPerm="update-patient"
              @editToggle="show(data.item)"
              @deleteToggle="deleteModel(data.item)"
            /> -->

            <!-- @click="printId(data.item.id)" -->
            <b-button class="mx-1" pill @click="
      $router.push({
        name: 'Reception-patient-preview',
        params: { id: data.item.id },
      })
      " variant="outline-primary" size="sm">
              {{ $t('common.preview') }}
            </b-button>
            <b-button pill size="sm" @click="
      $router.push({
        name: 'patient-card-history',
        params: { id: data.item.patient_card.patient.id },
      })
      " variant="outline-secondary">
              {{ $t('reception.patient-history') }}
            </b-button>
          </div>
        </template>
      </b-table>

      <template v-if="loading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner label="Loading..." />
          </div>
        </div>
      </template>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">Showing 1 to 10 patients</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getClinicPatients()">
            <b-pagination v-model="page" :total-rows="this.patientsTotal" :per-page="take" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
  <!-- Table Container Card -->
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIcon,
  BIconSearch,
  BModal,
  BAlert,
  VBModal,
  BCardText,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
import permissionChecker from '@/mixins/permissionChecker';
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
const ServicePriceAutoComplete = () => import("@/components/common/ServicePriceAutoComplete.vue");

const AutoComplete = () => import('@/components/common/AutoComplete.vue');

export default {
  mixins: [permissionChecker],
  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    AutoComplete,
    BPagination,
    BTooltip,
    vSelect,
    Datepicker,
    VuePhoneNumberInput,
    BFormGroup,
    BFormSelect,
    BIcon,
    BIconSearch,
    BSpinner,
    BModal,
    BAlert,
    BCardText,
    StatisticCardHorizontal,
    ServicePriceAutoComplete,
  },
  directives: {
    'b-modal': VBModal,
  },

  data() {
    return {
      tableColumns: [
        { key: 'name', sortable: true, label: this.$t('common.name') },
        {
          key: 'patient_card.card_no',
          label: this.$t('reception.card-no'),
          sortable: true,
        },

        { key: 'Phone', sortable: true, label: this.$t('reception.phone'), class: "text-nowrap" },
        {
          key: 'mother_name',
          sortable: true,
          label: this.$t('reception.patient-mother-name'),
        },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      genderOption: ['Male', 'Female'],

      patientName: '',
      patientMotherName: '',
      addForm: {
        name: '',
        mother_name: '',
        gender: '',
        birth_date: '',
        case_type: '',
        type: 'CLINIC',
        governorate_id:'',
        service_id:'',
        amount:'',
        city_name:"",
        invoices: [],
        phone: '',
        _method: 'POST',
      },
      errorForm: {
        name: '',
        mother_name: '',
        gender: '',
        governorate_id:'',
        service_id:'',
        amount:'',
        city_name:"",
        type: 'CLINIC',
        birth_date: '',
        case_type: '',
        phone: '',

      },
      take: 10,
      loading: true,
      selected: '',
      option: [],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      params: {
        form: {},
        path: '',
      },

      patientsData: [],
      patientsTotal: 0,
      statusFilter: null,
      filterData: {
        name: '',
        type: 'CLINIC',

        mother_name: '',
        gender: '',
        birth_date: '',
        case_type: '',
        phone: '',
      },
    };
  },
  mounted() {
    this.getClinicPatients();
  },
  methods: {
    show() {

      this.addForm = {
        name: '',
        mother_name: '',
        gender: '',
        type: 'CLINIC',
        birth_date: '',
        governorate_id:'',
        city_name:"",
        case_type: '',
        service_id:'',
        amount:'',
        phone: '',
        _method: 'POST',
      };
      this.$bvModal.show('modal-add-clinic-patient');
    },
    serviceValue(service) {
      this.addForm.service_id = service.id;
      this.addForm.amount = service.price;
    },


    async getClinicPatients() {
      this.loading = true;
      for (const [key, value] of Object.entries(this.filterData)) {
        if (value == null) {
          this.filterData[key] = '';
        }
      }

      let url = `/patient-clinic?page=${this.page}&take=${this.take}&sort=-id&include=patientCard`;

      if (this.patientName) {
        url += `&filter[name]=${this.patientName}`;
      }
      if (this.patientMotherName) {
        url += `&filter[mother_name]=${this.patientMotherName}`;
      }
      await this.getList(url);
      this.patientsTotal = this.all_data.total;
      this.patientsData = this.all_data.data;
      this.loading = false;
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },

    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, '0');
      const day = String(newDate.getDate()).padStart(2, '0');
      const hours = String(newDate.getHours()).padStart(2, '0');
      const minutes = String(newDate.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    submitItem() {
      this.addForm.birth_date = this.formatDate(this.addForm.birth_date);
      const invoices = [];
      invoices.push({
        service_id: this.addForm.service_id,
        status: 'pending',
        amount: this.addForm.amount,
      });

      delete this.addForm.service_id;
      delete this.addForm.amount;
      delete this.addForm.status;

      this.addForm.invoices = invoices;


      (this.params.form = this.addForm),
        (this.params.path = `patientWithCard`),
        this.$store
          .dispatch('create', this.params)
          .then(async (response) => {
this.getClinicPatients()
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },



  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
